<div
  class="ix-slidein-title-bar"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <h3 class="ix-formtitle">
    {{ title | translate }}
    <ix-readonly-badge *ngIf="requiredRoles?.length && !(hasRequiredRoles | async)"></ix-readonly-badge>
  </h3>

  <ng-container *ngIf="!disableClose">
    <ix-icon
      tabindex="0"
      name="cancel"
      id="ix-close-icon"
      (click)="close()"
      (keydown.enter)="close()"
    ></ix-icon>
  </ng-container>
</div>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
